import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
import { useLanguage } from './LanguageContext';
export function HistoricMoments() {
  const {
    t
  } = useLanguage();
  const moments = [{
    title: t('history.v1'),
    year: '2022',
    videoId: 'qkLMBq3FQOE',
    colSpan: 'md:col-span-2'
  }, {
    title: t('history.v2'),
    year: '2021',
    videoId: 'Nt0bLFHFMdI',
    colSpan: 'md:col-span-1'
  }, {
    title: t('history.v3'),
    year: '2022',
    videoId: 'YXvBBCI1JrY',
    colSpan: 'md:col-span-1'
  }, {
    title: t('history.v6'),
    year: '2024',
    videoId: 'HkQoPBjqBhc',
    colSpan: 'md:col-span-2'
  }, {
    title: t('history.v5'),
    year: '2000',
    videoId: 'dQw4w9WgXcQ',
    colSpan: 'md:col-span-1'
  }, {
    title: t('history.v4'),
    year: '1986',
    videoId: 'Gg8JKbTpn6k',
    colSpan: 'md:col-span-2'
  }, {
    title: t('history.v7'),
    year: '2019-2024',
    videoId: 'JGwWNGJdvx8',
    colSpan: 'md:col-span-1'
  }, {
    title: t('history.v8'),
    year: '2003-2023',
    videoId: 'kxH6YErFYIQ',
    colSpan: 'md:col-span-1'
  }, {
    title: t('history.v9'),
    year: '2018',
    videoId: 'T8OEbSRAJbo',
    colSpan: 'md:col-span-1'
  }, {
    title: t('history.v10'),
    year: '2021',
    videoId: 'W_38H_rJ2_8',
    colSpan: 'md:col-span-3'
  }];
  return <section className="py-12 md:py-24 bg-canada-black" data-id="element-172">
      <div className="container mx-auto px-6 md:px-12" data-id="element-173">
        <div className="mb-8 md:mb-12" data-id="element-174">
          <motion.h2 initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="text-canada-red font-oswald uppercase tracking-widest text-sm font-bold mb-3" data-id="element-175">
            {t('history.label')}
          </motion.h2>
          <motion.h3 initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-3xl md:text-5xl font-oswald font-bold uppercase" data-id="element-176">
            {t('history.title1')}{' '}
            <span className="text-canada-gold" data-id="element-177">{t('history.title2')}</span>
          </motion.h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-178">
          {moments.map((moment, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.05
        }} className={`relative rounded-2xl overflow-hidden aspect-video md:aspect-auto bg-[#111] ${moment.colSpan} ${moment.colSpan === 'md:col-span-2' || moment.colSpan === 'md:col-span-3' ? 'md:h-[400px]' : 'md:h-[400px]'}`} data-id="element-179">
              <a href={`https://www.youtube.com/watch?v=${moment.videoId}`} target="_blank" rel="noopener noreferrer" className="absolute inset-0 w-full h-full group cursor-pointer block" data-id="element-180">
                <img src={`https://img.youtube.com/vi/${moment.videoId}/maxresdefault.jpg`} alt={moment.title} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" onError={e => {
              // Fallback to hqdefault if maxresdefault is not available
              e.currentTarget.src = `https://img.youtube.com/vi/${moment.videoId}/hqdefault.jpg`;
            }} data-id="element-181" />
                <div className="absolute inset-0 bg-gradient-to-t from-canada-black via-canada-black/40 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" data-id="element-182"></div>

                {/* Play Button Overlay */}
                <div className="absolute inset-0 flex items-center justify-center transition-transform duration-300 transform group-hover:scale-110" data-id="element-183">
                  <div className="w-16 h-16 bg-canada-red/90 rounded-full flex items-center justify-center backdrop-blur-sm shadow-[0_0_30px_rgba(216,6,33,0.5)]" data-id="element-184">
                    <Play className="text-white ml-1" size={24} fill="currentColor" data-id="element-185" />
                  </div>
                </div>

                {/* YouTube badge */}
                <div className="absolute top-4 right-4 bg-[#FF0000] text-white text-[10px] font-oswald uppercase tracking-widest px-2 py-1 rounded flex items-center gap-1 z-10" data-id="element-186">
                  <Play size={10} fill="currentColor" data-id="element-187" /> YouTube
                </div>

                {/* Content */}
                <div className="absolute bottom-0 left-0 w-full p-6 md:p-8" data-id="element-188">
                  <span className="inline-block bg-canada-gold text-canada-black text-xs font-oswald uppercase tracking-widest px-2 py-1 rounded mb-3 font-bold" data-id="element-189">
                    {moment.year}
                  </span>
                  <h4 className="font-oswald text-xl md:text-3xl font-bold uppercase text-white drop-shadow-lg" data-id="element-190">
                    {moment.title}
                  </h4>
                </div>
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}